import axios from "@/request";
import qs from "qs";

export default {
  /* 操作权限检查 */
  async check(params: any) {
    return axios.get("stadium-cooperate/check", { params });
  },
  /* 提交合作 */
  async submit(params: any) {
    return axios.post("stadium-cooperate/submit", qs.stringify(params));
  },
}
